/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateProfile} from '../api'

export const useMutationUpdateProfile = createReactQueryMutationHook('updateProfile', updateProfile)
